import { createSlice } from '@reduxjs/toolkit';

import lang from '../config/lang';

const frState = { ...lang.french };
const enState = {
  ...lang.english,
};

const langSlice = createSlice({
  name: 'lang',
  initialState: frState,
  reducers: {
    changeLang: (state, action) => {
      let newState = frState;
      if (action.payload === lang.english.id) {
        newState = enState;
      }
      return newState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeLang } = langSlice.actions;

export default langSlice.reducer;
export const dictionary = (state) => state.lang.dictionary;
export const selectTranslation = (txt) => (state) => {
  const dictio = state.lang.dictionary;
  return dictio[txt] || txt;
};
export const selectTranslations = (keys) => (state) => {
  const dictio = state.lang.dictionary;
  return keys.reduce((acc, key) => {
    // eslint-disable-next-line no-param-reassign
    acc[key] = dictio[key] || key;
    return acc;
  }, {});
};
